import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {  Router, RouterLink } from '@angular/router';
import { MenuService } from '../common/menu.service';
import { SessionService } from '../common/session.service';
import { MessageService } from '../common/message.service';
import { AngularDeviceInformationService } from 'angular-device-information';

@Component({
    selector: 'app-menu',
    imports: [
        CommonModule,
        RouterLink
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.css'
})
export class MenuComponent implements OnInit {

 expandedMenus = new Set<string>();
  menuItems:any[]=[];
  profile:string ='';
  sessionInfo?:any;
  isMobile: boolean = false;
  activeMenu: string | null = null;
  constructor(private menuService:MenuService,
    private session:SessionService,
    public messageService:MessageService,
    private deviceInfo :AngularDeviceInformationService
  ){
    if (this.deviceInfo.isMobile() || this.deviceInfo.isTablet()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
  ngOnInit(): void {

     this.sessionInfo=this.session.getSessionInfo();
     this.profile = this.sessionInfo?.role?.code||'';
    this.menuItems = this.menuService.getMenu(this.profile);
  }
  


  toggleDropdown(id: string) {
    console.log('toggleDropdown', id);
    this.activeMenu = this.activeMenu === id ? null : id;
  }

}
